/**
 * WorkflowTreePage — /workflow/tree/:id
 *
 * The tree view for any submission. :id can be the root item or any
 * sub-task in it; the server walks up to the root and marks :id as
 * "you're here". Same visibility as the item page.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../api';
import { useIsMobile, Icon } from '../../mobile';
import WorkflowTree from '../components/WorkflowTree';

export default function WorkflowTreePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [tree, setTree] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setError(null);
      setTree(await api.getWorkflowTree(id));
    } catch (err) {
      setError(err.message || 'Could not load this tree');
    }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ padding: isMobile ? '0 0 24px' : '24px 32px 48px', maxWidth: isMobile ? undefined : 1280 }}>
      <button onClick={() => navigate(-1)} style={{
        background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer',
        fontSize: isMobile ? 15 : 13, marginBottom: 12, padding: isMobile ? '6px 0' : 0,
        display: 'inline-flex', alignItems: 'center', gap: 4, minHeight: isMobile ? 44 : undefined,
      }}>
        {isMobile ? <><Icon name="back" size={20} /> Back</> : '← Back'}
      </button>

      {error && (
        <div style={{ padding: 20, borderRadius: 10, background: '#fef2f2', color: '#991b1b', fontSize: 14 }}>
          {error}{' '}
          <button type="button" className="btn" onClick={load} style={{ marginLeft: 8 }}>Try again</button>
        </div>
      )}
      {!error && !tree && <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Loading…</div>}
      {tree && (
        <WorkflowTree tree={tree} onOpenItem={(itemId) => navigate(`/workflow/items/${itemId}`)} />
      )}
    </div>
  );
}
